/** ============================================================================
 * sectionNav
 *
 * @version   1.0.0
 * @author    Sam Rankin <srankin@riester.com>
 * @copyright 2022 RIESTER
 * ========================================================================== */
import { isBootstrapBP, isEmpty, listen, resizeListener } from '../../utils';

export default {
	name: 'sectionNav',
	addPopupToSectionNav() {
		const subNavBtn = document.getElementById('section-nav-btn');

		if (subNavBtn) {
			// eslint-disable-next-line
			const popup = bootstrap.Popover.getOrCreateInstance(subNavBtn, {
				trigger: 'hover',
				content: 'Hide Menu',
				placement: 'top',
			});

			if (!falsey(popup)) {
				if (!isBootstrapBP('lg')) {
					popup.disable();
				}

				resizeListener(
					() => {
						popup.enable();
					},
					() => {
						popup.disable();
					},
					'lg'
				);
			}
		}
	},
	openSectionNav(targetId = 'section-nav-wrapper') {
		if (!isEmpty(targetId)) {
			const target = document.getElementById(targetId);

			if (!isEmpty(target)) {
				const sectionNavCollapse = bootstrap.Collapse.getOrCreateInstance(target);
				const sidebar = target.closest('.page-sidebar');
				const sectionNavWrapper = target.closest('.sidebar-inner');

				sidebar.classList.add('is-opened');
				sectionNavCollapse.show();

				sectionNavWrapper.classList.remove('m-xxl-0');
			}
		}
	},
	closeSectionNav(targetId = 'section-nav-wrapper') {
		if (!isEmpty(targetId)) {
			const target = document.getElementById(targetId);

			if (!isEmpty(target)) {
				const sectionNavCollapse = bootstrap.Collapse.getOrCreateInstance(target);
				const sidebar = target.closest('.page-sidebar');
				const sectionNavWrapper = target.closest('.sidebar-inner');

				sidebar.classList.remove('is-opened');
				sectionNavCollapse.hide();

				sectionNavWrapper.classList.add('m-xxl-0');
			}
		}
	},
	sectionNavClick(event) {
		let el = event.target;
		el = el.closest('.btn');
		const targetId = el.getAttribute('aria-controls');
		if (!isEmpty(targetId)) {
			const target = document.getElementById(targetId);

			if (!isEmpty(target)) {
				const sectionNavCollapse = bootstrap.Collapse.getOrCreateInstance(target);
				const sidebar = target.closest('.page-sidebar');
				const sectionNavWrapper = target.closest('.sidebar-inner');

				sidebar.classList.toggle('is-opened');
				sectionNavCollapse.toggle();
				sectionNavWrapper.classList.toggle('m-xxl-0');
			}
		}
	},
	initSectionNav() {
		const ctx = this;
		const sectionNavBtn = document.getElementById('section-nav-btn');

		if (!isEmpty(sectionNavBtn)) {
			listen(sectionNavBtn, 'click', ctx.sectionNavClick, true, true);
			const sectionNavId = sectionNavBtn.getAttribute('aria-controls');
			if (!isEmpty(sectionNavId)) {
				const sectionNav = document.getElementById(sectionNavId);
				if (!isEmpty(sectionNav)) {
					if (isBootstrapBP('lg', 'max-width')) {
						ctx.closeSectionNav();
					}
					resizeListener(
						() => {
							if (!sectionNav.classList.contains('collapse-horizontal')) {
								sectionNav.classList.add('collapse-horizontal');
							}
						},
						() => {
							if (sectionNav.classList.contains('collapse-horizontal')) {
								sectionNav.classList.remove('collapse-horizontal');
							}
							ctx.closeSectionNav();
						},
						'lg'
					);
				}
			}
		}
	},
	init() {
		this.addPopupToSectionNav();
	},
	finalize() {
		this.initSectionNav();
	},
	resize() {},
};
